import { CHANGE_ENTERPRISE } from './common/user/userReducer';

let initialState;
const reducer = rootReducer => (state, action) => {
    const nextState = rootReducer(state, action);
    if (action.type === CHANGE_ENTERPRISE) {
        return {
            ...initialState,
            app: nextState.app //Keep app state the same since user has already authenticated
        };
    }

    if (!state) {
        initialState = nextState;
    }

    return nextState;
};

export default reducer;
